const styles = (theme) => ({
	containerModal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	container: {
		backgroundColor: theme.palette.secondary.darker,
		width: "450px",
		borderRadius: "16px",
		maxWidth: "80vw",
	},
	Avatar: {
		height: "90px",
		width: "90px",
		border: `solid 4px`,
		borderColor: theme.palette.secondary.darker,
		color: theme.palette.white.main,
		background:
			theme.palette.mode == "dark"
				? theme.palette.colors.gray.dark
				: theme.palette.black.light,
	},
	containerIconButton: {
		color: theme.palette.white.main,
		background: theme.palette.secondary.dark,
		"&:hover": {
			backgroundColor: theme.palette.paletteCharts.disable,
		},
	},
	BoxAvatar: {
		width: "126px",
		height: "126px",
		borderRadius: "50%",
		alignItems: "center",
		justifyContent: "center",
		display: "flex",
		marginLeft: "20px",
		marginBottom: "120px",
	},
	StackFoto: {
		alignItems: "center",
		height: "220px",
		position: "absolute",
		marginTop: "10px",
		marginRight: "320px",
	},
	boxAreaTituloModalPerfil: {
		position: "relative",
		width: "100%",
		height: "40px",
		mb: 1,
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "center",
	},
	boxAreaModalPerfil: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		padding: {
			xs: "20px",
			sm: "20px",
		},
	},
	boxAreaConteudoModalPerfil: {
		background: theme.palette.background.modalContrast,
		width: "100%",
		minHeight: "388px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: "20px",
		padding: "30px",
		paddingTop: "10px",
	},
	boxAreaButtomModalPerfil: {
		width: "100%",
		height: "36px",
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "flex-end",
	},
	containerButtonSalvar: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		mt: 2,
	},
	TextField: {
		fontSize: "16px",
		fontWeight: "600",
		width: "100%",
		borderRadius: "8px",
		bgcolor:
			theme.palette.mode == "dark"
				? theme.palette.secondary.dark
				: theme.palette.secondary.light,
		"& .MuiFilledInput-root": {
			backgroundColor: "transparent",
		},
		"& .Mui-disabled": {
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.light,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.darker
					: theme.palette.secondary.light,
		},
		"& .MuiInputLabel-filled": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.secondary.dark,
		},
		"& .MuiFilledInput-input": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.white.main
					: theme.palette.colors.black.dark,
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.colors.black.medium,
		},
	},
	divider: {
		width: "100%",
		margin: "10px 0px",
	},
	textBold: {
		fontWeight: "bold",
	},
	boxStatusItem: {
		position: "relative",
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "flex-start",
		gap: "6px",
		mt: "-1px",
	},

	button: {
		borderRadius: "10px",
	},
});

export default styles;
